var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-tab-container"},[_c('layout-tab',{ref:"layoutTab",attrs:{"bannerTemplate":{
      api: {
        url: '/purchaser/mall/bannerBottom/getBannerBottom',
        type: 'get'
      },
      keys: {
        logoKey: 'logoUrl',
        linkKey: 'logoLink'
      }
    },"defaultOpeneds":_vm.defaultOpeneds},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('public-header')]},proxy:true}])}),_vm._v(" "),(!_vm.$route.meta.hideSideFixed)?_c('side-fixed',{attrs:{"type":"fluid"}}):_vm._e(),_vm._v(" "),(!_vm.$route.meta.noNotice)?_c('SystemAnnouncement',{attrs:{"publishScope":"mall"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }